<template>
  <v-card dark class="edit candidate" v-if="candidate">
    <v-card-title primary-title>
      <div>
        <div class="headline">{{ candidate.profile.fullName }}</div>
        <span class="grey--text">{{ candidate.email }}</span>
      </div>
    </v-card-title>

    <v-alert color="error" transition="scale-transition" :value="candidate.errors">
      <ul><li v-for="(message, i) in candidate.errors" :key="`error-${i}`">{{ message }}</li></ul>
    </v-alert>

    <v-form @submit.prevent="$emit('update')" v-model="valid">
      <v-card-text>
        <v-text-field
          v-model="candidate.email"
          label="Email" type="email"
          required :rules="rules.email"
        />

        <v-text-field
         v-model="candidate.password"
         label="Password" type="password"
         hint="Leave this blank for it to remain unchanged"
        />
      </v-card-text>

      <v-card-actions><v-spacer />
        <v-btn flat @click="$emit('cancel')" color="grey">
          Cancel
        </v-btn>
        <v-btn type="submit" color="primary">
          Update Candidate
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
// Vue Component
export default {
  data() {
    return {
      // Validations
      valid: true,
      rules: {
        email: [
          v => !!v || 'must be provided',
          v => /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'must be a valid email address',
        ],
      }
    }
  },
  computed: {
    candidate() {
      return this.$store.getters['admin/candidates/find'](this.$route.params.id)
    },
  },
}
</script>
